import React, { Component } from 'react'
import {  message, Table, } from "antd"
import Store from 'app/stores/research/azf/report'
import { Provider, observer, inject } from 'mobx-react'
import {  SUCCESS } from 'app/utils/const'

@inject('reportStore', 'entrance') @observer
export default class DataTable extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
    this.state = {
      currentPageIndex: 1,
      totalCount: 0,
      dataIndex: 0,
      reportGroupData: {},
    }
  }
  componentDidMount() {
    const { location } = this.props
    const pathArr = location.pathname.split('/')
    const reportId = pathArr.slice(-1)[0]
    const { initTableData, updateTableData } = this.props.reportStore
    initTableData(reportId)
      .then(
        res => {
          updateTableData(res)
          if (pathArr.slice(-2)[0] === 'detail') {
            this.initDetailData(reportId)
          }
        },
        err => {
          message.error(err.message)
        }
      )
  }

  initDetailData = (reportId) => {
    const { getDetailData, tableData, clearDetailData } = this.props.reportStore
    const index = tableData.pointList.findIndex(report => report.reportId === reportId)
    if (index > -1) {
      clearDetailData()
      this.setState({
        dataIndex: index,
        reportGroupData: tableData
      })
      getDetailData(reportId)
    }
  }

  openDetail = (data, record) => {
    let { getDetailData, clearDetailData } = this.props.reportStore
    let { history, match } = this.props

    const index = data.reportList.findIndex(report =>
      report.reportId === record.reportId
    )

    clearDetailData()

    this.setState({
      dataIndex: index,
      reportGroupData: data
    })
    let reportId = data.reportList[index].reportId
    getDetailData(reportId)
      .then(res => {
        record.isRead = true
      })
    history.push({
      pathname: `${match.url}/detail/${reportId}`,
    })
  }
  checkOperatable = (record) => {
    return record.state === SUCCESS
  }

  dataSwitch = (index, record) => {
    let { getDetailData, clearDetailData } = this.props.reportStore
    clearDetailData()
    this.setState({
      dataIndex: index,
    })
    getDetailData(record.reportId)
      .then(res => {
        record.isRead = true
      })
  }

  copyText = (content) => {
    let targetId = "_hiddenCopyText_"
    let currentFocus = document.activeElement
    let target = document.getElementById(targetId)
    currentFocus.focus()

    // 如果不是，则使用节点的textContent
    if (!target) {
      //如果不存在，则创建一个
      target = document.createElement("textarea")
      target.style.position = "absolute"
      target.style.left = "-9999px"
      target.style.top = "0"
      target.id = targetId
      document.body.appendChild(target)
    }
    target.textContent = content
    // 聚焦目标节点，选中它的内容
    target.focus()
    target.setSelectionRange(0, target.value.length)

    // 进行复制操作
    try {
      document.execCommand("copy")
      message.success("复制链接成功")
    } catch (e) {
      message.error("复制链接失败")
    }

    // 不再聚焦
    if (currentFocus && typeof currentFocus.focus === "function") {
      currentFocus.focus()
    }

    // 清空临时数据
    target.textContent = ""
  }

  handleChange = (type, value, index) => {
    const { tableData } = this.props.reportStore
    const point = tableData.pointList[index]
    if (point[type]) {
      point[type] = value
    } else {
      if (type === 'state') {
        point['state'] = parseInt(value)// 将字符串转换成数字
      }
      if (type === 'percentage') {
        point['percentage'] = value
      }
    }
    this.forceUpdate()
  }
  render() {
    const { tableData } = this.props.reportStore
    this.columns = [
      {
        title: "区域",
        width:'25%',
        dataIndex: "type",
        render: ( text, index) => {
          const obj = {
            children:  <div>{text}</div>,
            props: {},
          }
          if (index <2) {
            obj.props.rowSpan = 2
          }
          return obj
        }
      }, {
        title: "STS",
        width:'25%',
        dataIndex: "point",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      },  {
        title: "缺失状态",
        width:'25%',
        className: "ta-l",
        dataIndex: "state",
        render: (text, record, index) => {
          return (
            // 0 未发现缺失 1 发现缺失
            <select
              className='inptxt'
              defaultValue={text === 1 ? 1 : 0}
              onChange={(e) => this.handleChange('state', e.target.value, index)}
            >
              <option value="0" key='0'>未发现缺失</option>
              <option value="1" key='1'>发现缺失</option>
            </select>
          )
        }
      }, {
        title: "缺失率",
        width:'25%',
        className: "ta-l",
        dataIndex: "percentage",
        render: (text, record, index) => {
          return (
              <input 
                className='inptxt' 
                value={text} 
                onChange={(e)=>this.handleChange('percentage', e.target.value,index)}>
              </input>
          )
        }
      }
    ]
    return (
      <Provider store={this.store}>
        <div>
          <div className='wrapper-box-azf'>
            <div>
              <Table
                className="pgd-datamanage-table"
                columns={this.columns}
                dataSource={tableData.pointList && tableData.pointList.slice()}
                rowKey={record => record.id}
                pagination={false}
              />
            </div>
          </div>
        </div>

      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/research/azf/data_manage_detail/containers/DataTable.js